export function toUpperCamelCase(str) {
  return str
    .split(/(\s+)/)
    .map((word) => {
      if (word.trim().length === 0) {
        return word; // Handle multiple spaces by returning the space
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");
}
